import React from "react";

const DEFAULT_ITEMS = [
  { id: "fastpay", label: "FastPay", icon: require("../../../assets/img/payTypes/fastpay.jpeg") },
  { id: "fib", label: "FiB", icon: require("../../../assets/img/payTypes/fib.jpeg") },
  { id: "zaincash", label: "ZainCash", icon: require("../../../assets/img/payTypes/zain.jpeg") },
  {
    id: "usdt",
    label: "USDT",
    icon: require("../../../assets/img/payTypes/usdt.jpeg"),
  },
  {
    id: "nasspay",
    label: "NASS PAY",
    icon: require("../../../assets/img/payTypes/nasspay.png"),
  },
  { id: "qicard", label: "QiCard", icon: require("../../../assets/img/payTypes/qicard.jpeg") },
];

const REPEAT_COUNT = 6;

const RibbonItem = ({ label, icon }) => {
  return (
    <div
      className="flex h-12 shrink-0 select-none items-center gap-2 rounded-md border border-white/15 bg-secondary-200/25 px-3 py-1.5 text-xs font-semibold tracking-wide text-white backdrop-blur-sm"
      style={{ WebkitTapHighlightColor: "transparent" }}
    >
      {icon ? (
        <img
          src={icon}
          alt=""
          className="h-7 w-auto max-w-[72px] rounded-md object-contain"
          aria-hidden
          draggable="false"
        />
      ) : null}
      <span className="font-sans font-bold text-white">{label}</span>
    </div>
  );
};

/**
 * Payment methods ribbon (marquee)
 *
 * Props:
 * - items?: {id: string, label: string}[]
 * - speedSeconds?: number (default 18)
 * - className?: string
 */
const Ribbon = ({ items = DEFAULT_ITEMS, speedSeconds = 18, className = "" }) => {
  return (
    <div
      className={[
        "relative w-full overflow-hidden rounded-md",
        "bg-gradient-to-r from-bg-secondary-500 via-bg-secondary-400 to-bg-secondary-600",
        "ring-1 ring-white/10",
        className,
      ].join(" ")}
      role="region"
      aria-label="Payment methods"
    >
      <style>{`
        .ribbon__track {
          display: flex;
          width: max-content;
          animation: ribbon-marquee var(--ribbon-speed, 18s) linear infinite;
          will-change: transform;
        }
        .ribbon__row {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 12px;
          white-space: nowrap;
        }
        .ribbon__container:hover .ribbon__track {
          animation-play-state: paused;
        }
        @keyframes ribbon-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(calc(-100% / ${REPEAT_COUNT})); }
        }
        @media (prefers-reduced-motion: reduce) {
          .ribbon__track { animation: none; }
        }
      `}</style>

      <div
        className="ribbon__container"
        style={{
          // eslint-disable-next-line react/no-unknown-property
          ["--ribbon-speed"]: `${Math.max(6, Number(speedSeconds) || 18)}s`,
        }}
      >
        <div className="ribbon__track">
          {Array.from({ length: REPEAT_COUNT }).map((_, rowIndex) => (
            <div className="ribbon__row" aria-hidden={rowIndex > 0 ? "true" : undefined} key={rowIndex}>
              {items.map((it) => (
                <RibbonItem
                  key={`${it.id}-${rowIndex}`}
                  label={it.label}
                  icon={it.icon}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ribbon;
